<div
  class="u-padding-0-16 u-paddingTop-16"
  fxLayout="row"
  fxLayoutAlign="start center"
>
  <div fxFlex="calc(100% - 104px)">
    <mat-form-field>
      <mat-icon matPrefix> search </mat-icon>
      <mat-label *ngIf="placeholder">
        <span i18n="@@searchBar.placeholder"
          >{ placeholder, select, other {{{ placeholder }}} }</span
        >
      </mat-label>
      <input [formControl]="searchForm" matInput autocomplete="off" />
    </mat-form-field>
  </div>
  <div
    *ngIf="showButtonIcon || showMoreOptions"
    fxFlex="104px"
    class="color-grey-300 u-paddingBottom-16"
    fxLayout="row"
    fxLayoutAlign="end center"
  >
    <ng-container *ngIf="showButtonIcon">
      <div fxLayout="row" fxLayoutAlign="center center">
        <a
          mat-icon-button
          (click)="buttonIconClick.emit()"
          class="u-display-block"
        >
          <mat-icon>{{ buttonIcon }}</mat-icon>
        </a>
      </div>
    </ng-container>
    <ng-container *ngIf="showMoreOptions">
      <mat-menu #moreOptionsMenu="matMenu">
        <button
          *ngFor="let option of moreOptions"
          mat-menu-item
          (click)="option.action()"
        >
          <span i18n="@@searchBar.menuOption"
            >{ option.label, select, other {{{ option.label }}} }</span
          >
        </button>
      </mat-menu>
      <div fxLayout="row" fxLayoutAlign="center center" class="u-marginLeft-8">
        <a
          mat-icon-button
          [matMenuTriggerFor]="moreOptionsMenu"
          class="u-display-block"
        >
          <mat-icon> more_vert </mat-icon>
        </a>
      </div>
    </ng-container>
  </div>
</div>
